import React, { Fragment, useContext, useEffect, useState } from "react";
import { LogOut } from "react-feather";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomizerContext from "../../_helper/Customizer";
import approvals from "../../assets/images/Icons/Approvals.svg";
import budget from "../../assets/images/Icons/Budget.svg";
import powo from "../../assets/images/Icons/Po:Wo.svg";
import projectDashboard from "../../assets/images/Icons/Project Dashboard.svg";
import projectFiles from "../../assets/images/Icons/ProjectFiles.svg";
import settings from "../../assets/images/Icons/Settings.svg";
import vendors from "../../assets/images/Icons/Vendors.svg";
import { poViewGranted } from "../../utils/PermissionFunctions/userPermissions";
import SidebarMenu from "./SidebarMenu";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const SideBarLayout = (props) => {
  const MENUITEMS = [
    {
      menutitle: "Applications",
      Items: [
        {
          title: "Project Dashboard",
          icon: { projectDashboard },
          type: "link",
          active: window?.location?.pathname == "/project-dashboard",
          path: `/project-dashboard`,
          inner: true,
          outer: false,
        },
        {
          title: "Budget",
          icon: budget,
          type: "link",
          active: window?.location?.pathname == "/app/project/budget",
          path: `/app/project/budget`,
          inner: true,
          outer: false,
        },
        !poViewGranted(props.settings.user)
          ? {
              title: "Po/Wo",
              icon: powo,
              type: "link",
              active: window?.location?.pathname == "/app/project/powo",
              path: `/app/project/powo`,
              inner: true,
              outer: false,
            }
          : {},
        {
          title: "Project",
          icon: projectFiles,
          type: "link",
          active: window?.location?.pathname == "/app/project/project-list",
          path: `/app/project/project-list`,
          inner: false,
          outer: true,
        },
        {
          title: "Vendors",
          icon: vendors,
          type: "link",
          active: window?.location?.pathname == "/app/vendor/vendor-list",
          path: `/app/vendor/vendor-list`,
          inner: true,
          outer: true,
        },
        {
          title: "Approvals",
          icon: approvals,
          type: "link",
          active: window?.location?.pathname == "/app/approval/approvals",
          path: `/app/approval/approvals`,
          inner: true,
          outer: true,
        },
        // {
        //   path: `/app/organisation`,
        //   icon: GitPullRequest,
        //   title: "Organisation",
        //   type: "link",
        // },
        // {
        //   title: "Explore",
        //   icon: explore,
        //   type: "link",
        //   active: window?.location?.pathname == "/app/ecommerce/product",
        //   path: `/app/ecommerce/product`,
        //   inner: true,
        //   outer: true,
        // },
        {
          title: "Settings",
          icon: settings,
          type: "link",
          active: window?.location?.pathname == "/app/project/project-settings",
          path: `/app/project/project-settings`,
          inner: true,
          outer: false,
        },
        {
          title: "Logout",
          icon: LogOut,
          type: "logout",
          active: false,
          // path: `/app/project/project-settings`,
          inner: false,
          outer: true,
        },
      ],
    },
  ];
  const location = useLocation();

  const { toggleIcon } = useContext(CustomizerContext);
  const [currentUrl] = useState(window.location.pathname);
  const id = window.location.pathname.split("/").pop();
  // eslint-disable-next-line
  const [leftArrow, setLeftArrow] = useState(false);
  const layout = id;
  const [width, setWidth] = useState(0);
  const handleResize = () => {
    setWidth(window.innerWidth - 500);
  }; // eslint-disable-next-line
  const [mainmenu, setMainMenu] = useState([]);
  const handleScroll = () => {
    if (window.scrollY > 400) {
      document.querySelector(".main-navbar").className = "main-navbar hovered";
    } else {
      if (document.getElementById("main-navbar"))
        document.querySelector(".main-navbar").className = "main-navbar";
    }
  };

  const setNavActive = (item) => {
    MENUITEMS.map((menuItems) => {
      menuItems.Items.filter((Items) => {
        if (Items !== item) {
          Items.active = false;
          document.getElementById("bg-overlay1").classList.remove("active");
        }
        if (Items.children && Items.children.includes(item)) {
          Items.active = true;
        }
        if (Items.children) {
          Items.children.filter((submenuItems) => {
            if (submenuItems.children && submenuItems.children.includes(item)) {
              Items.active = true;
              submenuItems.active = true;
              return true;
            } else {
              return false;
            }
          });
        }
        return Items;
      });
      return menuItems;
    });
    setMainMenu({ mainmenu: MENUITEMS });
  };
  useEffect(() => {
    console.log("Hello 1");
    setLeftArrow(true);
    window.addEventListener("resize", handleResize);
    handleResize();
    const {
      user,
      settings: { project, projectSelected },
    } = props;
    var menuFinal = [];
    MENUITEMS.map((each) => {
      var outerMenu = {
        menutitle: each.menutitle,
        Items: [],
      };
      var innerMenu = [];
      for (var i = 0; i < each.Items.length; i++) {
        var item = each.Items[i];
        if (item.outer && item.inner) {
          innerMenu.push(item);
        } else if (!item.outer && item.inner) {
          if (projectSelected) {
            innerMenu.push(item);
          }
        } else if (item.outer && !item.inner) {
          if (!projectSelected) {
            innerMenu.push(item);
          }
        }
      }
      outerMenu.Items = innerMenu;
      menuFinal.push(outerMenu);
    });
    console.log(menuFinal, "sss");
    setMainMenu(menuFinal);

    // const currentUrl = window.location.pathname;
    // MENUITEMS.map(items => {
    //   items.Items.filter((Items) => {
    //     if (Items.path === currentUrl)
    //       setNavActive(Items);
    //     if (!Items.children) return false;
    //     Items.children.filter(subItems => {
    //       if (subItems.path === currentUrl)
    //         setNavActive(subItems);
    //       if (!subItems.children) return false;
    //       subItems.children.filter(subSubItems => {
    //         if (subSubItems.path === currentUrl) {
    //           setNavActive(subSubItems);
    //           return true;
    //         } else {
    //           return false;
    //         }
    //       });
    //       return subItems;
    //     });
    //     return Items;
    //   });
    //   return items;
    // });
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
    // eslint-disable-next-line
  }, [layout, currentUrl, location]);

  const closeOverlay = () => {
    document.getElementById("bg-overlay1").classList.remove("active");
    document.getElementById("nav-link").classList.remove("active");
  };

  return (
    <Fragment>
      {console.log("Hello")}
      <div
        id="bg-overlay1"
        onClick={() => {
          closeOverlay();
        }}
      ></div>
      <header
        style={{ width: "230px", top: "70px", paddingTop: 10 }}
        className={`main-nav ${toggleIcon ? "close_icon" : ""}`}
      >
        {/* <Profile /> */}
        <SidebarMenu
          mainMenu={mainmenu}
          setMainMenu={setMainMenu}
          props={props}
          sidebartoogle={true}
          setNavActive={setNavActive}
          width={width}
        />
      </header>
    </Fragment>
  );
};
export default connect(mapStateToProps)(SideBarLayout);
